import React from 'react';
import './DataAnalysis.css';
import { Pie, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DataAnalysis = ({ employees, matrixCategories }) => {
  // 计算各类别人数
  const categoryStats = matrixCategories.flat().reduce((acc, category) => {
    acc[category.name] = employees.filter(emp => emp.category === category.name).length;
    return acc;
  }, {});

  // 计算潜力分布
  const potentialStats = {
    '高': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.potential === '高'
    ).length,
    '中': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.potential === '中'
    ).length,
    '低': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.potential === '低'
    ).length
  };

  // 计算绩效分布
  const performanceStats = {
    '高': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.performance === '高'
    ).length,
    '中': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.performance === '中'
    ).length,
    '低': employees.filter(emp => 
      matrixCategories.flat().find(c => c.name === emp.category)?.performance === '低'
    ).length
  };

  // 饼图数据
  const pieData = {
    labels: Object.keys(categoryStats),
    datasets: [
      {
        data: Object.values(categoryStats),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
        ],
      },
    ],
  };

  // 柱状图数据
  const barData = {
    labels: ['潜力分布', '绩效分布'],
    datasets: [
      {
        label: '高',
        data: [potentialStats['高'], performanceStats['高']],
        backgroundColor: '#4CAF50',
      },
      {
        label: '中',
        data: [potentialStats['中'], performanceStats['中']],
        backgroundColor: '#FFC107',
      },
      {
        label: '低',
        data: [potentialStats['低'], performanceStats['低']],
        backgroundColor: '#F44336',
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '潜力与绩效分布对比'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    }
  };

  return (
    <div className="data-analysis">
      <div className="analysis-header">
        <h2>数据分析报告</h2>
        <div className="summary-stats">
          <div className="stat-item">
            <div className="stat-value">{employees.length}</div>
            <div className="stat-label">总人数</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {categoryStats['明星人才'] || 0}
            </div>
            <div className="stat-label">明星人才</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {categoryStats['核心人才'] || 0}
            </div>
            <div className="stat-label">核心人才</div>
          </div>
        </div>
      </div>

      <div className="charts-container">
        <div className="chart-section">
          <h3>人才类别分布</h3>
          <div className="pie-chart">
            <Pie data={pieData} />
          </div>
        </div>
        <div className="chart-section">
          <h3>潜力绩效分布</h3>
          <div className="bar-chart">
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
      </div>

      <div className="detailed-stats">
        <h3>详细统计</h3>
        <div className="stats-grid">
          {Object.entries(categoryStats).map(([category, count]) => (
            <div key={category} className="stat-card">
              <div className="stat-card-header">{category}</div>
              <div className="stat-card-value">{count}</div>
              <div className="stat-card-percentage">
                {((count / employees.length) * 100).toFixed(1)}%
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataAnalysis; 